import api from './api.config'
// import axios from 'axios'
export default new class catraca {
  async list (data) {
    var res = await api.axios.get('/catraca/list', { params: { matricula: data } })
    return res.data
  }
}()
